
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Mumbaiairporttopunecabs() {



  const cardData =
  {
    keyword: 'Mumbai Airport To Pune Cab',
    heading: 'SHREE Tours & Travels: Mumbai Airport To Pune Cab',
    headingDescription: 'SHREE Tours & Travels offers a dependable Mumbai Airport to Pune Cab service, ensuring a smooth and hassle-free transfer from Chhatrapati Shivaji Maharaj International Airport to Pune. Whether you are traveling for business, leisure, or returning home, our well-maintained Cabs and professional drivers provide a safe and comfortable ride. With on-time pickups, flexible booking options and affordable fares, we make your airport transfer stress-free. Choose SHREE Tours & Travels for a reliable Mumbai Airport to Pune travel experience.',

    top: 'Top Places to Visit in Pune  with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "Shaniwar Wada is an iconic historical fortification in Pune, built in 1732 as the residence of the Peshwas of the Maratha Empire. The grand entrance, Delhi Darwaza, leads visitors into the remains of a once-majestic palace, known for its intricate wooden carvings and sprawling gardens. Although much of it was destroyed in a fire in 1828, the structure still stands as a symbol of Pune's rich history. The fort is also famous for its rumored paranormal activities, making it an intriguing spot for history buffs and adventure seekers."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Aga Khan Palace is a stunning piece of architecture built in 1892 by Sultan Muhammed Shah Aga Khan III. This palace holds great significance in Indian history as it served as a prison for Mahatma Gandhi, Kasturba Gandhi and other freedom fighters during the Quit India Movement. The palace now functions as a museum, showcasing rare photographs, memorabilia and personal items of Gandhi. The lush green lawns and Italian arches add to the beauty of this national heritage site, making it a must-visit for history lovers."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Perched atop the Sahyadri Hills, Sinhagad Fort is a historic fortress that played a crucial role in various battles, including the famous Battle of Sinhagad in 1670. The fort offers breathtaking views of the surrounding landscapes and is a favorite trekking destination for adventure enthusiasts. At the top, visitors can explore remnants of old fortifications, temples and memorials while enjoying traditional Maharashtrian snacks like Kanda Bhaji and Pithla Bhakri. The fort’s cool climate and rich history make it a perfect weekend getaway."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "Dagdusheth Halwai Ganpati Temple is one of the most revered temples in Pune, dedicated to Lord Ganesha. The temple was built by a sweet merchant, Dagdusheth Halwai, in memory of his late son. The idol of Lord Ganesha is adorned with gold ornaments and attracts thousands of devotees, especially during the Ganesh Chaturthi festival. The temple is known for its vibrant atmosphere, devotional music and grand celebrations that showcase the deep spiritual and cultural roots of Pune."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Raja Dinkar Kelkar Museum houses a fascinating collection of over 20,000 artifacts, including musical instruments, sculptures, paintings and antique household items from different parts of India. Established by Dr. Dinkar Kelkar in memory of his son, the museum provides insights into India’s diverse artistic heritage. One of the highlights is the Mastani Mahal, a reconstructed section of the original palace of Mastani, the wife of Peshwa Bajirao I. The museum is a paradise for art lovers and history enthusiasts."
    },
    {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city from an elevation of 2,100 feet. The hilltop is home to the Parvati Temple, dedicated to Goddess Parvati and Lord Shiva. The temple complex also includes shrines for Lord Ganesha, Lord Vishnu and Kartikeya. The climb up 103 steps is rewarded with a peaceful ambiance, making it a great spot for meditation, photography and witnessing beautiful sunrises and sunsets."
    },
    {
        "title": "Osho Ashram",
        "description": "The Osho International Meditation Resort in Pune is a globally renowned spiritual retreat dedicated to the teachings of Osho Rajneesh. The ashram offers a variety of meditation programs, wellness workshops and relaxation therapies. With its tranquil gardens, serene meditation halls and Zen-inspired architecture, the ashram attracts visitors from around the world seeking inner peace and spiritual growth. The unique blend of traditional and modern meditation techniques makes it a one-of-a-kind experience."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a Japanese-style landscape garden inspired by the Korakuen Garden in Okayama, Japan. Spread over 10 acres, the garden features beautifully designed ponds, bridges, waterfalls and lush greenery, creating a tranquil and picturesque setting. It’s an ideal place for nature lovers, photographers and families looking for a peaceful escape within the city."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "The Pataleshwar Cave Temple is an ancient rock-cut cave temple dedicated to Lord Shiva. Carved out of a single basalt rock in the 8th century, this temple is reminiscent of the famous Ellora Caves. The temple complex features a massive Nandi bull, intricate carvings and a circular stone courtyard. Its historical and architectural significance, coupled with a serene atmosphere, makes it a hidden gem in Pune’s cultural landscape."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Khadakwasla Dam, located about 20 km from Pune, is a popular weekend spot known for its scenic beauty and cool breeze. The dam supplies water to Pune city and is surrounded by lush greenery, making it an excellent picnic and photography location. Nearby attractions like Sinhagad Fort and Panshet Dam add to its appeal. Visitors can enjoy street food, leisurely walks and a peaceful escape from city life."
    }
],  
    
            
"services": [
    {
      "name": "Mumbai Airport to Pune Taxi",
      "description": "Travel comfortably and conveniently with our Mumbai Airport to Pune taxi service. Whether you're arriving from an international or domestic flight, our professional drivers will ensure you have a smooth journey with prompt pickups and timely arrivals."
    },
    {
      "name": "Mumbai Airport to Pune Cab Service",
      "description": "Book a reliable and comfortable Cab service for your journey from Mumbai Airport to Pune. Our fleet of well-maintained vehicles, coupled with experienced drivers, guarantees a safe and pleasant ride to Pune, whether it's for business or leisure."
    },
    {
      "name": "Mumbai Airport to Pune One-Way Taxi",
      "description": "Need a one-way taxi from Mumbai Airport to Pune? Enjoy a hassle-free ride with our one-way taxi service, designed for travelers who want a quick and affordable transfer from the airport to Pune without worrying about return trips or additional charges."
    },
    {
      "name": "Mumbai Airport to Pune Round Trip Cab",
      "description": "Looking for a round-trip from Mumbai Airport to Pune? Our round-trip Cab service offers the flexibility of a return journey as per your schedule, making it ideal for travelers who want to explore Pune or need a return trip after their stay."
    },
    {
      "name": "Affordable Mumbai Airport to Pune Cab",
      "description": "Looking for an affordable yet comfortable ride from Mumbai Airport to Pune? Our budget-friendly taxi services ensure that you get the best rates without compromising on quality or comfort. Travel with peace of mind knowing you're getting the best deal."
    },
    {
      "name": "Private Taxi for Pune from Mumbai Airport",
      "description": "For a personalized experience, book a private taxi from Mumbai Airport to Pune. Our private taxi service ensures complete comfort and privacy, with the flexibility to travel according to your schedule and preferences."
    },
    {
      "name": "Pune Travel from Mumbai Airport by Cab",
      "description": "Planning to travel from Mumbai Airport to Pune? Our Cab service provides you with a smooth, comfortable and reliable ride to Pune, whether you're traveling for business, leisure, or a quick weekend getaway. Let us handle your travel with convenience and care."
    },
    {
      "name": "Group Travel to Pune from Mumbai Airport",
      "description": "Traveling with a group? Our spacious vehicles are perfect for group travel from Mumbai Airport to Pune. Enjoy the convenience of traveling together in comfort, with ample space for luggage and a professional driver ensuring a smooth journey."
    },
    {
      "name": "Book Mumbai Airport to Pune Car",
      "description": "Booking a car for your journey from Mumbai Airport to Pune is easy with SHREE Tours & Travels. Choose from a variety of vehicles, including sedans, SUVs and larger cars, to suit your needs for comfort, space and style during your transfer."
    },
    {
      "name": "Mumbai Airport Cab Booking",
      "description": "Book your taxi from Mumbai Airport to Pune effortlessly with our online booking service. With just a few clicks, you can secure a reliable and timely ride, ensuring a smooth and stress-free transfer from the airport to your destination."
    },
    {
      "name": "Pune Transfer from Mumbai Airport",
      "description": "Looking for a seamless transfer from Mumbai Airport to Pune? Our transfer service is designed to ensure timely and comfortable travel, with professional drivers who are well-acquainted with the best routes to make your journey smooth and efficient."
    },
    {
      "name": "Mumbai Airport to Pune Drop",
      "description": "If you're looking for a drop-off from Mumbai Airport to Pune, we provide a hassle-free and punctual service. Whether you’re arriving early morning or late at night, our drivers are ready to ensure you reach your destination comfortably and on time."
    },
    {
      "name": "Pune Trip from Mumbai Airport",
      "description": "Start your Pune trip in the most comfortable way possible by booking a taxi from Mumbai Airport. Whether it's your first time visiting Pune or you're a frequent traveler, our Cab service offers a seamless ride with friendly drivers and a reliable fleet of vehicles."
    }
  ],
  "tableData": [
    ["- Mumbai Airport to Pune Taxi", "- Mumbai Airport to Pune Cab Service"],
    ["- Mumbai Airport to Pune One-Way Taxi", "- Mumbai Airport to Pune Round Trip Cab"],
    ["- Affordable Mumbai Airport to Pune Cab", "- Private Taxi for Pune from Mumbai Airport"],
    ["- Pune Travel from Mumbai Airport by Cab", "- Group Travel to Pune from Mumbai Airport"],
    ["- Book Mumbai Airport to Pune Car", "- Mumbai Airport Cab Booking"],
    ["- Pune Transfer from Mumbai Airport", "- Mumbai Airport to Pune Drop"],
    ["- Pune Trip from Mumbai Airport"]
  ],


  
  whychoose: [
    {
      "WhyChooseheading": "Convenient and Comfortable Ride",
      "WhyChoosedescription": "Our Mumbai Airport to Pune Cab service offers a convenient and comfortable ride, ensuring that you travel in style and comfort after your flight. With air-conditioned vehicles and spacious seating, you can relax and enjoy a smooth ride to Pune without any hassle."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our experienced drivers are well-versed in the best routes from Mumbai Airport to Pune, ensuring a safe and timely journey. They are courteous, professional and dedicated to making your ride smooth, ensuring you reach your destination relaxed and on time."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer affordable and transparent pricing for your Mumbai Airport to Pune Cab ride. With no hidden charges, we provide you with the best value for your money, ensuring a budget-friendly option while maintaining excellent service standards."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "Our fleet of vehicles is regularly serviced and maintained to ensure they are in top condition for your journey. Each vehicle is equipped for your comfort and safety, ensuring a smooth and worry-free ride from Mumbai Airport to Pune."
    },
    {
      "WhyChooseheading": "Easy and Quick Booking Process",
      "WhyChoosedescription": "Booking your Mumbai Airport to Pune Cab is quick and easy with SHREE Tours & Travels. You can book your ride online through our user-friendly platform or contact our customer service team for assistance. We make sure the booking process is simple and convenient."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Mumbai Airport to Pune Cab needs. Whether you have a late-night flight or an early morning arrival, our round-the-clock service ensures we are available to accommodate your schedule at any time of day or night."
    },
    {
      "WhyChooseheading": "Reliable and Timely Service",
      "WhyChoosedescription": "We understand the importance of punctuality, especially when catching a flight or after a long journey. Our drivers are committed to providing timely service, ensuring you reach your destination without delays, giving you peace of mind throughout your ride."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, we prioritize customer satisfaction. We are committed to delivering excellent service, making sure your Mumbai Airport to Pune ride is smooth, comfortable and hassle-free. We guarantee a positive experience that meets your travel needs every time."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  
  
  



        
  }
  const faqData = [
    {
        question: "How can I book a Cab from Mumbai Airport to Pune?",
        answer: "You can easily book your Mumbai Airport to Pune Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Mumbai Airport to Pune route?",
        answer: "We offer a variety of vehicles for the Mumbai Airport to Pune journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Mumbai Airport to Pune inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Mumbai Airport to Pune?",
        answer: "Yes, we offer one-way rental options for your Mumbai Airport to Pune trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Mumbai Airport to Pune trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Mumbai Airport to Pune Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Mumbai Airport to Pune Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Mumbai Airport to Pune trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Mumbai Airport to Pune?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Mumbai Airport to Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The journey from Mumbai Airport to Pune was seamless. The driver was professional and the ride was smooth and comfortable.',
        name: 'Mr. Akash Patel',
    },
    {
        text: 'I had a fantastic experience with SHREE Tours & Travels. The driver was on time and the vehicle was in excellent condition for the trip.',
        name: 'Miss. Anjali Verma',
    }
];












  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];



const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Mumbai Airport to Pune Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/mumbai-airport-to-pune-cab.jpg",
    "https://shreetoursandtravels.in/img/pune-trip-cab.jpg"
  ],
  "priceRange": "₹2000 - ₹4000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/mumbai-airport-to-pune-cab-service",
    "priceCurrency": "INR",
    "price": 3000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.7,
    "reviewCount": 1200
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Amit Deshmukh"
      },
      "datePublished": "2024-12-01",
      "reviewBody": "Great service! The Cab was comfortable and the driver was very professional. Smooth ride from Mumbai Airport to Pune. Highly recommend!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Priya Joshi"
      },
      "datePublished": "2024-12-10",
      "reviewBody": "Very convenient service for airport transfer. The driver was on time and the ride was comfortable. Will definitely use again."
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Mumbai Airport to Pune Cab Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 19.0760,  // Mumbai latitude
      "longitude": 72.8777  // Mumbai longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/mumbai-airport-to-pune-cab-service"
  },
  "keywords": "Mumbai Airport to Pune Taxi, Mumbai Airport to Pune Cab Service, Mumbai Airport to Pune One-Way Taxi, Mumbai Airport to Pune Round Trip Cab, Affordable Mumbai Airport to Pune Cab, Private Taxi for Pune from Mumbai Airport, Pune Travel from Mumbai Airport by Cab, Group Travel to Pune from Mumbai Airport, Book Mumbai Airport to Pune Car, Mumbai Airport Cab Booking, Pune Transfer from Mumbai Airport, Mumbai Airport to Pune Drop, Pune Trip from Mumbai Airport"
};



  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Mumbai Airport to Pune Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Mumbai Airport to Pune Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Mumbai Airport to Pune Taxi, Mumbai Airport to Pune Cab Service, Mumbai Airport to Pune One-Way Taxi, Mumbai Airport to Pune Round Trip Cab, Affordable Mumbai Airport to Pune Cab, Private Taxi for Pune from Mumbai Airport, Pune Travel from Mumbai Airport by Cab, Group Travel to Pune from Mumbai Airport, Book Mumbai Airport to Pune Car, Mumbai Airport Cab Booking, Pune Transfer from Mumbai Airport, Mumbai Airport to Pune Drop, Pune Trip from Mumbai Airport" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/15.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Mumbaiairporttopunecabs;